module.exports = __webpack_public_path__ + "static/media/s_v10_14.015b0165.mp3";